import React from "react";
import linkifyHtml from "linkify-html";

const LINKIFY_OPTIONS = { defaultProtocol: "https", attributes: { rel: "noopener", target: "_blank", class: "likified-link" } };

export default function LinkifiedText(props) {
  const linkifiedText = linkifyHtml(props.text || "", LINKIFY_OPTIONS);
  return <span dangerouslySetInnerHTML={{ __html: linkifiedText }} style={{ whiteSpace: "pre-wrap" }}></span>;
}



// WEBPACK FOOTER //
// ./src/components/linkified_text.js